import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Modal, ModalFooter, ModalHeader, ModalBody, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

import { useTranslations } from '../../hooks/useTranslations';

export const DELETE_LOCALE_MODAL_TEST_IDS = {
  body: 'locale-delete-modal-body',
  btnDelete: 'locale-delete-modal-btn-delete',
  header: 'locale-delete-modal-header',
  modal: 'locale-delete-modal',
};

export type DeleteLocaleModalProps = {
  closeModal: () => void;
  onDelete: () => void;
  locale: string;
};

export const DeleteLocaleModal = ({ closeModal, onDelete, locale }: DeleteLocaleModalProps) => {
  const { t } = useTranslations();

  return (
    <Modal
      data-test={DELETE_LOCALE_MODAL_TEST_IDS.modal}
      id={DELETE_LOCALE_MODAL_TEST_IDS.modal}
      isModalOpen={true}
      onClose={closeModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader autoFocus={false} data-test={DELETE_LOCALE_MODAL_TEST_IDS.header}>
        <span>{t('header.deleteLocale')}</span>
      </ModalHeader>
      <ModalBody data-test={DELETE_LOCALE_MODAL_TEST_IDS.body}>
        Are you sure you want to delete <strong>{locale}</strong>? This cannot be undone.
      </ModalBody>
      <ModalFooter>
        <Button
          data-test={DELETE_LOCALE_MODAL_TEST_IDS.btnDelete}
          onClick={onDelete}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.DESTRUCTIVE}
        >
          <span>{t('button.deleteLocale')}</span>
        </Button>
      </ModalFooter>
    </Modal>
  );
};
